import { createApp } from "vue";
import { createPinia } from "pinia";
import ElementPlus from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "element-plus/dist/index.css";
import App from "./App.vue";
import router from "./router";
import "./assets/styles/main.scss";
import AOS from "aos";
import "aos/dist/aos.css";

// 创建应用实例
const app = createApp(App);

// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

// 初始化 AOS
AOS.init({
  duration: 1000,
  once: true,
  offset: 100,
});

app.use(createPinia());
app.use(router);
app.use(ElementPlus);

app.mount("#app");
